import gql from 'graphql-tag'

export const UPDATE_DEFAULT_PAYMENT_METHOD = gql`
  mutation UpdateDefaultPaymentMethod($accountId: String!, $paymentMethodId: String!) {
    defaultPaymentMethod(accountId: $accountId, paymentMethodId: $paymentMethodId)
  }
`

export const UPDATE_DISPLAY_SUBSCRIPTION = gql`
  mutation UpdateDisplaySubscription(
    $accountId: String!
    $billingCycle: BillingCycle
    $planName: PlanEnums
    $quantity: Int
    $cirrusStandardQty: Int
  ) {
    updateSubscription(
      subscriptionPayloadDTO: {
        accountId: $accountId
        billingCycle: $billingCycle
        planName: $planName
        quantity: $quantity
        cirrusStandardQty: $cirrusStandardQty
      }
    ) {
      id
      accountId
      stripeSubscriptionId
      qty
      status
      planName
      stripeCustomerId
      cirrusStandardQty
      category
      trialEnd
      billingCycle
    }
  }
`

export const ACTIVATE_SUBSCRIPTION = gql`
  mutation ActivateSubscription(
    $accountId: String!
    $category: SubscriptionCategoryEnum
    $stripeSubscriptionId: String
  ) {
    activateSubscription(
      subscriptionPayloadDTO: {
        accountId: $accountId
        category: $category
        stripeSubscriptionId: $stripeSubscriptionId
      }
    ) {
      id
      accountId
      stripeSubscriptionId
      qty
      status
      planName
      stripeCustomerId
      cirrusStandardQty
      category
      trialEnd
      billingCycle
    }
  }
`

export const UPDATE_CUSTOMER_ADDRESS = gql`
  mutation UpdateCustomerAddress($stripeCustomerId: String!, $shipping: ShippingDTO!) {
    updateCustomerAddress(
      stripeShippingDTO: { stripeCustomerId: $stripeCustomerId, shipping: $shipping }
    ) {
      id
      shipping {
        name
        phone
        address {
          city
          country
          line1
          line2
          postal_code
          state
        }
      }
      invoice_settings {
        default_payment_method {
          card {
            brand
            last4
            exp_month
            exp_year
          }
        }
      }
    }
  }
`

export const UPDATE_CIRRUS_STANDARD_QUANTITY = gql`
  mutation UpdateCirrusStandardQuantity(
    $getLatestSubscriptionDTO: GetLatestSubscriptionDTO!
    $cirrusStandardQty: Int
    $quantity: Int
  ) {
    updateCirrusStandardQuantity(
      updateCirrusStandardQtyDTO: {
        getLatestSubscriptionDTO: $getLatestSubscriptionDTO
        cirrusStandardQty: $cirrusStandardQty
        quantity: $quantity
      }
    ) {
      id
      accountId
      stripeSubscriptionId
      qty
      status
      planName
      stripeCustomerId
      cirrusStandardQty
      category
      trialEnd
      billingCycle
    }
  }
`

export const DELETE_PAYMENT_METHOD = gql`
  mutation DeletePaymentMethod($paymentMethodId: String!) {
    deletePaymentMethod(paymentMethodId: $paymentMethodId) {
      id
      type
      card {
        brand
        last4
        exp_month
        exp_year
      }
    }
  }
`

export const PW_CANCEL_SUBSCRIPTION = gql`
  mutation CancelSubscriptionByAccount($stripeSubscriptionId: String!) {
    cancelSubscription(stripeSubscriptionId: $stripeSubscriptionId) {
      id
      stripeSubscriptionId
      status
    }
  }
`

export const PW_PAY_CELLULAR_INVOICE_WITH_SAVED_CARD = gql`
  mutation PwPayCellularInvoiceWithSavedCard(
    $accountId: String!
    $invoiceId: String!
    $expectedAmountUsd: Float
  ) {
    payCellularInvoiceWithSavedCard(
      accountId: $accountId
      invoiceId: $invoiceId
      expectedAmountUsd: $expectedAmountUsd
    ) {
      paid
      status
      message
      hostedInvoiceUrl
      paymentIntentClientSecret
      achState
      verificationUrl
      achCountsAsPaid
    }
  }
`

export const PW_PAY_CELLULAR_INVOICE_WITH_PAYMENT_METHOD = gql`
  mutation PwPayCellularInvoiceWithPaymentMethod(
    $accountId: String!
    $invoiceId: String!
    $paymentMethodId: String!
    $expectedAmountUsd: Float
  ) {
    payCellularInvoiceWithPaymentMethod(
      accountId: $accountId
      invoiceId: $invoiceId
      paymentMethodId: $paymentMethodId
      expectedAmountUsd: $expectedAmountUsd
    ) {
      paid
      status
      message
      hostedInvoiceUrl
      paymentIntentClientSecret
      achState
      verificationUrl
      achCountsAsPaid
    }
  }
`

// A SetupIntent for adding a US bank account (ACH) to pay this invoice.
export const PW_CREATE_CELLULAR_ACH_SETUP_INTENT = gql`
  mutation PwCreateCellularAchSetupIntent($accountId: String!, $invoiceId: String) {
    createCellularAchSetupIntent(accountId: $accountId, invoiceId: $invoiceId) {
      setupIntentId
      clientSecret
    }
  }
`

export const PW_PAY_CELLULAR_INVOICE_WITH_BANK_ACCOUNT = gql`
  mutation PwPayCellularInvoiceWithBankAccount(
    $accountId: String!
    $invoiceId: String!
    $setupIntentId: String!
    $expectedAmountUsd: Float
  ) {
    payCellularInvoiceWithBankAccount(
      accountId: $accountId
      invoiceId: $invoiceId
      setupIntentId: $setupIntentId
      expectedAmountUsd: $expectedAmountUsd
    ) {
      paid
      status
      message
      hostedInvoiceUrl
      paymentIntentClientSecret
      achState
      verificationUrl
      achCountsAsPaid
    }
  }
`

export const PW_GIVE_UP_CELLULAR = gql`
  mutation PwGiveUpCellular($accountId: String!, $stripeSubscriptionId: String!) {
    giveUpCellular(accountId: $accountId, stripeSubscriptionId: $stripeSubscriptionId) {
      ok
      gaveUpAt
    }
  }
`
